import { render, staticRenderFns } from "./ApprovedEntries.vue?vue&type=template&id=d1126bc6&"
import script from "./ApprovedEntries.vue?vue&type=script&lang=js&"
export * from "./ApprovedEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports